export function getDataFilterboxSoftener (softenerFilterDocument, messages, screenType)  {
  const data = [
    [
      {
        text: messages.history_events_date,
        name: 'date',
      },
      {
        text: messages.history_events_time,
        name: 'time',
      },
      {
        text: messages.history_events_event,
        name: 'event',
      },
    ],
    [
      {
        text: messages.history_events_daily_water_usage,
        name: 'daily_water_usage',
      },
      {
        text: messages.history_events_weekly_water_usage,
        name: 'weekly_water_usage',
      },
      {
        text: messages.history_events_monthly_water_usage,
        name: 'monthly_water_usage',
      },
      {
        text: messages.history_events_total_water_usage,
        name: 'total_water_usage',
      },
      {
        text: messages.history_events_untreated_water_flow,
        name: 'untreated_water_flow',
      },
      {
        text: messages.history_events_water_flow,
        name: 'water_flow',
      },
    ],
    [
      {
        text: messages.history_events_water_pressure,
        name: 'water_pressure',
      },
      {
        text: messages.history_events_max_water_pressure,
        name: 'max_water_pressure',
      },
      {
        text: messages.history_events_min_water_pressure,
        name: 'min_water_pressure',
      },
      {
        text: messages.history_events_max_water_flow,
        name: 'max_water_flow',
      },
    ],
    [
      {
        text: messages.history_events_normal_regeneration_number,
        name: 'normal_regeneration_number',
      },
      {
        text: messages.history_events_service_regeneration_number,
        name: 'service_regeneration_number',
      },
      {
        text: messages.history_events_incomplete_regeneration_number,
        name: 'incomplete_regeneration_number',
      },
    ],
    getReserveData(messages, screenType),
    [
      {
        text: messages.history_events_chlor_current,
        name: 'chlor_current',
      },
      {
        text: messages.history_events_ip_address,
        name: 'ip_address',
      },
      {
        text: messages.history_events_subnet_mask,
        name: 'subnet_mask',
      },
      {
        text: messages.history_events_default_gateway,
        name: 'default_gateway',
      },
      {
        text: messages.history_events_device_operator,
        name: 'device_operator',
      },
      {
        text: messages.history_events_record_no,
        name: 'record_no',
      },
    ],
  ];
  return data;
};

export function getDataFilterboxSuperior (superiorFilterDocument, messages) {
  const data = [
    [
      {
        text: messages.history_events_superior_date,
        name: 'date',
      },
      {
        text: messages.history_events_superior_time,
        name: 'time',
      },
      {
        text: messages.history_events_superior_event,
        name: 'event',
      },
    ],
    [
      {
        text: messages.history_events_superior_current_refill_flow,
        name: 'current_refill_flow',
      },
      {
        text: messages.history_events_superior_refill_flow_rate,
        name: 'refill_flow_rate',
      },
      {
        text: messages.history_events_superior_total_refill_volume,
        name: 'total_refill_volume',
      },
      {
        text: messages.history_events_superior_system_pressure,
        name: 'system_pressure',
      },
      {
        text: messages.history_events_superior_total_refill_time,
        name: 'total_refill_time',
      },
      {
        text: messages.history_events_superior_total_degass_time,
        name: 'total_degass_time',
      },
    ],
    [
      {
        text: messages.history_events_superior_device_operator,
        name: 'device_operator',
      },
      {
        text: messages.history_events_superior_record_no,
        name: 'record_no',
      },
    ],
  ];
  return data;
};

export function getReserveData(messages, screenType){
  switch (screenType) {
    case 'DOUBLEALTERNATIVE':
    case 'DOUBLEPARALLEL':
    case 'DOUBLEFILTER':
      return [
        {
          text: messages.history_events_a_cylinder_reserve,
          name: 'a_cylinder_reserve',
        },
        {
          text: messages.history_events_c_cylinder_reserve,
          name: 'c_cylinder_reserve',
        },
      ];
    case 'TRIPLEALTERNATIVE':
    case 'TRIPLEPARALLEL':
    case 'TRIPLEFILTER':
      return [
        {
          text: messages.history_events_b_cylinder_reserve,
          name: 'b_cylinder_reserve',
        },
        {
          text: messages.history_events_a_cylinder_reserve,
          name: 'a_cylinder_reserve',
        },
        {
          text: messages.history_events_c_cylinder_reserve,
          name: 'c_cylinder_reserve',
        },
      ];
    default:
      return [
        {
          text: messages.history_events_a_cylinder_reserve,
          name: 'a_cylinder_reserve',
        },
      ];
  }
}


// WEBPACK FOOTER //
// ./src/components/HistoryEvents/utils.js